import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Input, Checkbox, Row, Col, message, Tabs,Select,Table,Radio } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';

import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import "./RolesHierarchy.css";
import AwsServerService from '../../../common/util/AwsServerService';
import { Update } from "@material-ui/icons";

const SelectableRoleNode = ({ node, onSelect }) => {
  const [open, setOpen] = useState(true);

  return (
    <li>
      <div className="role-row" style={{ cursor: "pointer" }}>
        {node.children?.length > 0 && (
          <span className="toggle" onClick={() => setOpen(!open)}>
            {open ? "−" : "+"}
          </span>
        )}
        <span
          className="role-name"
          onClick={() => {
            onSelect(node);
          }}
        >
        {node.RoleName}
        </span>
      </div>

      {node.children && open && node.children.length > 0 && (
        <ul>
          {node.children.map(child => (
            <SelectableRoleNode key={child.ROWID} node={child} onSelect={onSelect} />
          ))}
        </ul>
      )}
    </li>
  );
};
const defaultPermissionsData = [
  { key: "1", module: "Leads", access: "Private" },
  { key: "2", module: "Accounts", access: "Private" },
  { key: "3", module: "Contacts", access: "Private" },
  { key: "4", module: "Deals", access: "Private" },
  { key: "5", module: "Campaigns", access: "Private" },
  { key: "6", module: "Tasks", access: "Private" },
  { key: "7", module: "Meetings", access: "Private" },
  { key: "8", module: "Cases", access: "Private" },
  { key: "9", module: "Solutions", access: "Private" },
];
const permissionColumns = [
  {
    title: "Module",
    dataIndex: "module",
    key: "module",
  },
  {
    title: "Default Access",
    dataIndex: "access",
    key: "access",
    render: (text) => (
      <Select defaultValue={text} style={{ width: 140 }}>
        <Select.Option value="Private">Private</Select.Option>
        <Select.Option value="Public Read Only">Public Read Only</Select.Option>
        <Select.Option value="Public Read/Write">Public Read/Write</Select.Option>
      </Select>
    ),
  },
];

const RoleNode = ({
  node,
  onEdit,
  onDelete,
  onAddChild,
  expandedKeys,
  setExpandedKeys
}) => {
  console.log("Node;-",node)
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(true);
  const isOpen = expandedKeys.has(node.ROWID);
  const getAllChildIds = (node) => {
    let ids = [node.ROWID];
    if (node.children) {
      node.children.forEach(child => {
        ids = ids.concat(getAllChildIds(child));
      });
    }
    return ids;
  };
  const handleToggle = () => {
    const newSet = new Set(expandedKeys);

    if (isOpen) {
      newSet.delete(node.ROWID);
    } else {
      const allIds = getAllChildIds(node);
      allIds.forEach(id => newSet.add(id));
    }
    setExpandedKeys(newSet);
  };
  return (
    <li>
      <div
        className="role-row"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {node?.children && node?.children.length > 0 && (
          <span className="toggle" onClick={handleToggle}>
            {isOpen ? "−" : "+"}
          </span>
        )}

        <span className="role-name">{node?.RoleName}</span>

        {hover && (
          <span className="role-actions">
            <PlusOutlined
              title="Add Role"
              onClick={() => onAddChild(node)}
            />
            <EditOutlined
              title="Edit Role"
              onClick={() => onEdit(node)}
            />
            <DeleteOutlined
              title="Delete Role"
              onClick={() => onDelete(node)}
            />
          </span>
        )}
      </div>

      {node?.children && isOpen && node?.children.length > 0 && (
        <ul>
          {node?.children.map((child) => (
            <RoleNode
              key={child?.ROWID}
              node={child}
              onEdit={onEdit}
              onDelete={onDelete}
              onAddChild={onAddChild}
              expandedKeys={expandedKeys}
              setExpandedKeys={setExpandedKeys}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const RolesHierarchy = () => {
  const [initialRolesData, setInitialRolesData] = useState([]);
    const [openSharingRuleModal, setOpenSharingRuleModal] = useState(false);
const [sharingRuleType, setSharingRuleType] = useState(null);
const [module, setModule] = useState(); // default value
const [sharingRuleName, setSharingRuleName] = useState("");
const [sharingType, setSharingType] = useState("owner"); // 'owner' or 'criteria'
const [recordsSharedFromType, setRecordsSharedFromType] = useState("Groups");
const [recordsSharedFromValue, setRecordsSharedFromValue] = useState(null);
const [recordsSharedToType, setRecordsSharedToType] = useState("Groups");
const [recordsSharedToValue, setRecordsSharedToValue] = useState(null);
const [permission, setPermission] = useState("Read/Write/Delete");
const [superiorsAllowed, setSuperiorsAllowed] = useState(false);

const [expandedKeys, setExpandedKeys] = useState(new Set());
const getAllChildIds = (node) => {
  let ids = [node.ROWID];

  if (node.children) {
    node.children.forEach(child => {
      ids = ids.concat(getAllChildIds(child));
    });
  }

  return ids;
};
const handleExpandAll = () => {
  let allIds = [];

  rolesData.forEach(root => {
    allIds = allIds.concat(getAllChildIds(root));
  });

  setExpandedKeys(new Set(allIds));
};

const handleCollapseAll = () => {
  setExpandedKeys(new Set());
};
  function buildHierarchy(data) {
    const map = {};
    const roots = [];

    data.forEach(item => {
      map[item.ROWID] = { ...item, children: [] };
    });

    data.forEach(item => {
      if (item.ReportingId === null) {
        // root node
        roots.push(map[item.ROWID]);
      } else {
        const parent = map[item.ReportingId];
        if (parent) {
          parent.children.push(map[item.ROWID]);
        }
      }
    });

    return roots;
  }
  const [rolesData, setRolesData] = useState([]);
  const fetRoles = () => {
    AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
      const hierarchicalData = buildHierarchy(res.data);
      console.log("hierarchicalData:-",hierarchicalData[0])
      setInitialRolesData(hierarchicalData);
      setRolesData(hierarchicalData);

    }).catch(err => {
      console.log(err);
    })
  }
  useEffect(()=>{
    fetRoles();
  },[])
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    ROWID: null,
    RoleName: "",
    ReportingId: "",
    RoleType: "",  
    shareWithPeers: false,
    Description: "",
    parentId: null,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [openReportsModal, setOpenReportsModal] = useState(false);
const [selectedManager, setSelectedManager] = useState(null);
const [criteriaList, setCriteriaList] = useState([
  { id: 1, field: null, condition: null, value: "", operator: "AND" },
]);

const toggleOperator = (id) => {
  setCriteriaList(
    criteriaList.map(c =>
      c.id === id
        ? { ...c, operator: c.operator === "AND" ? "OR" : "AND" }
        : c
    )
  );
};

const addCriteria = () => {
  setCriteriaList([
    ...criteriaList,
    { id: Date.now(), field: null, condition: null, value: "", operator: "AND" },
  ]);
};


const removeCriteria = (id) => {
  const newList = criteriaList.filter(c => c.id !== id);
  if(newList.length > 0) newList[0].operator = "AND"; // first has no operator visually
  setCriteriaList(newList);
};


const updateCriteria = (id, key, value) => {
  setCriteriaList(
    criteriaList.map(c =>
      c.id === id ? { ...c, [key]: value } : c
    )
  );
};

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Recursive function to add child role by parent id
const addChildRole = (parent, newRole) => {
if (parent.ROWID === newRole.ReportingId)
 {
    parent.children = parent.children || [];
    parent.children.push(newRole);
    return true;
  }
  if (parent.children) {
    for (let child of parent.children) {
      if (addChildRole(child, newRole)) return true;
    }
  }
  return false;
};


  // Recursive function to update role name/desc by id
const updateRole = (node, updatedRole) => {
  if (node.ROWID === updatedRole.ROWID) {
    return {
      ...node,
      RoleName: updatedRole.RoleName,
      Description: updatedRole.Description,
      ReportingId: updatedRole.ReportingId, // ✅ update ReportingId
    };
  }

  if (node.children) {
    return {
      ...node,
      children: node.children.map(child =>
        updateRole(child, updatedRole)
      ),
    };
  }

  return node;
};


  // Recursive function to delete role by id
  const deleteRole = (node, idToDelete) => {
    if (!node) return null;
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .filter(child => child.ROWID !== idToDelete)
        .map(child => deleteRole(child, idToDelete));
    }
    return node;
  };

  // Open modal for adding new role under a parent
  const handleAddChild = (parentNode) => {
    setIsEditing(false);
    setFormData({
      ROWID: null,
      RoleName: "",
      RoleType: parentNode.RoleType || "",
      ReportingId: parentNode.ROWID || null, 
      shareWithPeers: false,
      Description: "",
      parentId: parentNode.ROWID, 
    });
    setSelectedManager(parentNode);
    setOpenModal(true);
  };
const findRoleById = (tree, id) => {
  for (let node of tree) {
    if (node.ROWID === id) return node;
    if (node.children) {
      const found = findRoleById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};

  // Open modal for editing role
const handleEdit = (node) => { 
  setIsEditing(true);

  let reportsToName = "";
  if (node.ReportingId) {
    const parentRole = findRoleById(rolesData, node.ReportingId);
    if (parentRole) reportsToName = parentRole.RoleName;
  }

  setFormData({
    ROWID: node.ROWID,
    RoleName: node.RoleName,
    RoleType: node.RoleType || "", 
    ReportingId: node.ReportingId || null,  // ✅ populate correctly
    shareWithPeers: false,
    Description: node.Description || "",
    parentId: node.ReportingId || null,
  });

  setSelectedManager(
    node.ReportingId ? findRoleById(rolesData, node.ReportingId) : null
  );

  setOpenModal(true);
};


  // Confirm delete role
  const handleDelete = (node) => {
    if (window.confirm(`Are you sure you want to delete the role "${node.RoleName}"?`)) {
      let updatedRoles = rolesData;
      updatedRoles = rolesData
          .map(root => deleteRole(root, node.ROWID))
          .filter(Boolean);

        setRolesData(updatedRoles);

        AwsServerService.CrudServiceHandler({
          method: "DELETE",
          data: {
            ROWID: node.ROWID,
          },
          route: "ROLES",
        }).then(res => {
          fetRoles();
          message.success("Role deleted successfully!");
        });
      
      setOpenModal(false);
      resetForm()
    }
  };

  // Save role from modal
const handleSave = () => {
  if (!formData.RoleName.trim()) {
    message.error("Role Name is required!");
    return;
  }

  const newRolesData = rolesData.map(root =>
    updateRole(root, {
      ROWID: formData.ROWID,
      RoleName: formData.RoleName,
      Description: formData.Description,
      RoleType: formData.RoleType,
      ReportingId: formData.ReportingId || null, // ✅ important
    })
  );

  setRolesData(newRolesData); // UI turant update

  // Optional: API call
  if(!isEditing){
    AwsServerService.CrudServiceHandler({
      method: "POST",
      data: {
        ROWID: formData.ROWID,
        RoleName: formData.RoleName,
        Description: formData.Description,
        RoleType: formData.RoleType,
        ReportingId: formData.ReportingId || null,
      },
      route: "ROLES",
    }).then(res=>{
      fetRoles();
      message.success("Role Created successfully!");
    });
  } else if(isEditing) {
    AwsServerService.CrudServiceHandler({
      method: "PUT",
      data: {
        ROWID: formData.ROWID,
        RoleName: formData.RoleName,
        Description: formData.Description,
        ReportingId: formData.ReportingId || null,
        RoleType: formData.RoleType,
      },
      route: "ROLES",
    }).then(res=>{
      fetRoles();
      message.success("Role updated successfully!");
    })
  } else if("Delete"){

  }
  setOpenModal(false);
  resetForm()
};

  // Open modal to add root role
  const handleNewRootRole = () => {
    resetForm();
    setIsEditing(false);
    setOpenModal(true);
  };
const resetForm = () => {
  setFormData({
    ROWID: null,
    RoleName: "",
    ReportingId: "",
    RoleType: "",
    shareWithPeers: false,
    Description: "",
    parentId: null,
  });

  setSelectedManager(null);
};
  // Recursive function to render RoleNode tree with root role included
const renderRootAndChildren = () => {
  if (!rolesData || rolesData.length === 0) return null;
  return (
    <ul className="roles-tree" style={{height:"55vh", overflow:"auto"}}>
      {rolesData.map(root => (
        <RoleNode
          key={root.ROWID} // unique key is mandatory
          node={root}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onAddChild={handleAddChild}
          expandedKeys={expandedKeys}
          setExpandedKeys={setExpandedKeys}
        />
      ))}
    </ul>
  );
};



  return (
    <div className="roles-wrapper">
      <Tabs defaultActiveKey="1" className="custom-nested-tabs">
        <Tabs.TabPane tab="Roles" key="1">
      <div className="roles-header">
        <Button type="primary" onClick={handleNewRootRole}>
          New Role
        </Button>
        <span className="expand-actions">
          <button style={{border:"none"}} onClick={handleExpandAll}>Expand All</button>
          {" | "}
          <button style={{border:"none"}} onClick={handleCollapseAll}>Collapse All</button>
        </span>
      </div>

      <Card title="Roles" style={{height: "70vh"}}>{renderRootAndChildren()}</Card>

      {/* Modal for New Role / Edit Role */}
      <Modal
        title={isEditing ? "Edit Role" : "Create New Role"}
        open={openModal}
        onCancel={() => {resetForm(); setOpenModal(false)}}
        footer={[
          <Button key="cancel" onClick={() => {resetForm(); setOpenModal(false)}}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>,
        ]}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label>Role Name:</label>
            <Input
              placeholder="Enter role name"
              value={formData.RoleName}
onChange={(e) => handleChange("RoleName", e.target.value)}            />
          </Col>

          <Col span={24}>
            <label>Reports To:</label>
            <Input
              placeholder="Select manager"
         value={selectedManager?.RoleName || ""}

              readOnly
              onClick={() => setOpenReportsModal(true)}
            />
      <Modal
        title="Select"
        open={openReportsModal}
        onCancel={() => setOpenReportsModal(false)}
        footer={null}
        width={400}
      >
     <div style={{ maxHeight: 300, overflowY: "auto" }}>
  {Array.isArray(rolesData)
    ? rolesData.map(root => (
        <ul className="roles-tree" key={root.id}>
          <SelectableRoleNode
            node={root}
   onSelect={(role) => {
  setSelectedManager(role);
  setFormData(prev => ({
    ...prev,
    ReportingId: role.ROWID, // ✅ update ReportingId
    parentId: role.ROWID,
  }));
  setOpenReportsModal(false);
}}

          />
        </ul>
      ))
    : (
      <ul className="roles-tree">
        <SelectableRoleNode
          node={rolesData}
          onSelect={(role) => {
            setSelectedManager(role);
            setFormData(prev => ({
              ...prev,
              ReportingId: role.ROWID, // ✅ update ReportingId
              parentId: role.ROWID,
            }));
            setOpenReportsModal(false);
          }}

        />
      </ul>
    )
  }
</div>

      </Modal>

          </Col>

          {/* <Col span={24}>
            <Checkbox
              checked={formData.shareWithPeers}
              onChange={(e) => handleChange("shareWithPeers", e.target.checked)}
            >
              Share Data with Peers
            </Checkbox>
          </Col> */}
          <Col span={24}>
            <label>Role Type</label>
            {/* <Input
              placeholder="Enter Role Type"
              value={formData.RoleType}
              onChange={(e) => handleChange("RoleType", e.target.value)}
            /> */}
            <Select
              value={formData.RoleType}
              onChange={(val)=>{
                handleChange("RoleType", val)
              }}
            >
              <Select.Option value={"Zoho"}>Internal</Select.Option>
              <Select.Option value={"Account"}>Account</Select.Option>
              <Select.Option value={"Deal"}>Deal</Select.Option>
              <Select.Option value={"Vendor"}>Vendor</Select.Option>
              <Select.Option value={"Other"}>Other Contacts Role</Select.Option>
            </Select>
          </Col>

          <Col span={24}>
            <label>Description:</label>
            <Input.TextArea
              rows={3}
              placeholder="Enter description"
              value={formData.Description}
              onChange={(e) => handleChange("Description", e.target.value)}/>
          </Col>
        </Row>
      </Modal>
      </Tabs.TabPane>
  <Tabs.TabPane tab="Data Sharing Settings" key="2">
    <Tabs defaultActiveKey="defaultPermissions" type="line" size="small" className="custom-nested-tabs">
      <Tabs.TabPane tab="Default Organization Permissions" key="defaultPermissions">
        <Card>
          <Table
            columns={permissionColumns}
            dataSource={defaultPermissionsData}
            pagination={false}
            bordered
            scroll={{x:800, y:300}}
          />
        </Card>
      </Tabs.TabPane>
      {/* Commented the Sharing rule tab. */}
      {/* <Tabs.TabPane tab="Sharing Rules" key="sharingRules">
        <Card
          title="Sharing Rules"
          extra={
            <Button
              type="primary"
              onClick={() => setOpenSharingRuleModal(true)}
            >
              Create Sharing Rule
            </Button>
          }
        >
        </Card>
      </Tabs.TabPane> */}
    </Tabs>
  </Tabs.TabPane>
</Tabs>
<Modal
  title="New Sharing Rule"
  open={openSharingRuleModal}
  onCancel={() => setOpenSharingRuleModal(false)}
  onOk={() => {
    // Validation
    if (!sharingRuleName.trim()) {
      message.error("Sharing Rule Name is required!");
      return;
    }
    // Aap yaha form data submit bhi kar sakte hain
    setOpenSharingRuleModal(false);
  }}
  okText="Save"
  cancelText="Cancel"
>
  <Row gutter={[16, 16]}>
<Col span={24} style={{ marginTop: 12 }}>
  <Row align="middle" gutter={8}>

    {/* Label */}
    <Col flex="200px">
      <span style={{ fontWeight: 500 }}>Module</span>
    </Col>

    {/* Select */}
    <Col flex="auto">
      <Select
        value={module}
        onChange={(value) => setModule(value)}
        style={{ width: "100%" }}
        placeholder="Select Module"
      >
        <Select.Option value="Leads">Leads</Select.Option>
        <Select.Option value="Accounts">Accounts</Select.Option>
        <Select.Option value="Contacts">Contacts</Select.Option>
      </Select>
    </Col>

  </Row>
</Col>

<Col span={24} style={{ marginTop: 12 }}>
  <Row align="middle" gutter={8}>

    {/* Label */}
    <Col flex="200px">
      <span style={{ fontWeight: 500 }}>
        Sharing Rule Name <span style={{ color: "red" }}>*</span>
      </span>
    </Col>

    {/* Input */}
    <Col flex="auto">
      <Input
        placeholder="Enter Sharing Rule Name"
        value={sharingRuleName}
        onChange={(e) => setSharingRuleName(e.target.value)}
        status={sharingRuleName.trim() === "" ? "error" : ""}
      />
    </Col>

  </Row>
</Col>


    <Col span={24} style={{ marginTop: 10 }}>
      <label style={{ fontWeight: 500 }}>Sharing Type</label>
      <Radio.Group
        onChange={(e) => setSharingType(e.target.value)}
        value={sharingType}
      >
        <Radio value="owner">Based on Record Owner</Radio>
        <Radio value="criteria">Based on Criteria</Radio>
      </Radio.Group>
    </Col>
{sharingType === "criteria" && (
  <Col span={24} style={{ marginTop: 16 }}>
    {criteriaList.map((c, index) => (
      <div key={c.id}>

        {/* AND / OR clickable */}
        {index > 0 && (
          <div
            onClick={() => toggleOperator(c.id)}
            style={{
              margin: "8px 0",
              fontWeight: 600,
              cursor: "pointer",
              color: "#1677ff",
              userSelect: "none",
            }}
          >
            {c.operator}
          </div>
        )}

        <Row align="middle" gutter={8}>
          {/* Field */}
          <Col flex="200px">
            <Select
              placeholder="Field"
              value={c.field}
              onChange={(v) => updateCriteria(c.id, "field", v)}
              style={{ width: "100%" }}
            >
              <Select.Option value="Status">Status</Select.Option>
              <Select.Option value="Source">Source</Select.Option>
            </Select>
          </Col>

          {/* Condition */}
          <Col flex="160px">
            <Select
              placeholder="Condition"
              value={c.condition}
              onChange={(v) => updateCriteria(c.id, "condition", v)}
              style={{ width: "100%" }}
            >
              <Select.Option value="equals">Equals</Select.Option>
              <Select.Option value="contains">Contains</Select.Option>
            </Select>
          </Col>

          {/* Value */}
          <Col flex="auto">
            <Input
              placeholder="Value"
              value={c.value}
              onChange={(e) =>
                updateCriteria(c.id, "value", e.target.value)
              }
            />
          </Col>

          {/* Actions */}
<Col>
  <Button
    icon={<PlusCircleOutlined />}
    onClick={() => addCriteria()}
    style={{
      border: "none",
      color: "green",
      padding: "4px",
      fontSize: "16px",
    }}
  />
  {criteriaList.length > 1 && (
    <Button
      icon={<MinusCircleOutlined />}
      onClick={() => removeCriteria(c.id)}
      style={{
        border: "none",
        color: "red",
        padding: "4px",
        fontSize: "16px",
      }}
    />
  )}
</Col>

        </Row>
      </div>
    ))}
  </Col>
)}



      <>
<Col span={24} style={{ marginTop: 12 }}>
  <Row align="middle" gutter={8}>
    
    {/* Label */}
    <Col flex="180px">
      <span style={{ fontWeight: 500 }}>Records Shared From</span>
    </Col>

    {/* Type Select */}
    <Col flex="140px">
      <Select
        value={recordsSharedFromType}
        onChange={(value) => setRecordsSharedFromType(value)}
        style={{ width: "100%" }}
      >
        <Select.Option value="Groups">Groups</Select.Option>
        <Select.Option value="Roles">Roles</Select.Option>
        <Select.Option value="Users">Users</Select.Option>
      </Select>
    </Col>

    {/* Value Select */}
    <Col flex="auto">
      <Select
        placeholder="Select"
        value={recordsSharedFromValue}
        onChange={(value) => setRecordsSharedFromValue(value)}
        style={{ width: "100%" }}
      >
        {recordsSharedFromType === "Groups" && (
          <>
            <Select.Option value="group1">Group 1</Select.Option>
            <Select.Option value="group2">Group 2</Select.Option>
          </>
        )}
        {recordsSharedFromType === "Roles" && (
          <>
            <Select.Option value="role1">Role 1</Select.Option>
            <Select.Option value="role2">Role 2</Select.Option>
          </>
        )}
        {recordsSharedFromType === "Users" && (
          <>
            <Select.Option value="user1">User 1</Select.Option>
            <Select.Option value="user2">User 2</Select.Option>
          </>
        )}
      </Select>
    </Col>

  </Row>
</Col>


<Col span={24} style={{ marginTop: 12 }}>
  <Row align="middle" gutter={8}>

    {/* Label */}
    <Col flex="180px">
      <span style={{ fontWeight: 500 }}>Records Shared To</span>
    </Col>

    {/* Type Select */}
    <Col flex="140px">
      <Select
        value={recordsSharedToType}
        onChange={(value) => setRecordsSharedToType(value)}
        style={{ width: "100%" }}
      >
        <Select.Option value="Groups">Groups</Select.Option>
        <Select.Option value="Roles">Roles</Select.Option>
        <Select.Option value="Users">Users</Select.Option>
      </Select>
    </Col>

    {/* Value Select */}
    <Col flex="auto">
      <Select
        placeholder="Select"
        value={recordsSharedToValue}
        onChange={(value) => setRecordsSharedToValue(value)}
        style={{ width: "100%" }}
      >
        {recordsSharedToType === "Groups" && (
          <>
            <Select.Option value="group1">Group 1</Select.Option>
            <Select.Option value="group2">Group 2</Select.Option>
          </>
        )}
        {recordsSharedToType === "Roles" && (
          <>
            <Select.Option value="role1">Role 1</Select.Option>
            <Select.Option value="role2">Role 2</Select.Option>
          </>
        )}
        {recordsSharedToType === "Users" && (
          <>
            <Select.Option value="user1">User 1</Select.Option>
            <Select.Option value="user2">User 2</Select.Option>
          </>
        )}
      </Select>
    </Col>

  </Row>
</Col>


        <Col span={24} style={{ marginTop: 10 }}>
          <label>Permission</label>
          <Select
            style={{ width: "100%" }}
            value={permission}
            onChange={(value) => setPermission(value)}
          >
            <Select.Option value="Read">Read</Select.Option>
            <Select.Option value="Read/Write">Read/Write</Select.Option>
            <Select.Option value="Read/Write/Delete">Read/Write/Delete</Select.Option>
          </Select>
        </Col>

        <Col span={24} style={{ marginTop: 10 }}>
          <Checkbox
            checked={superiorsAllowed}
            onChange={(e) => setSuperiorsAllowed(e.target.checked)}
          >
            Superiors Allowed
          </Checkbox>
        </Col>
      </>
  



  </Row>
</Modal>
    </div>
    
  );
};

export default RolesHierarchy;
////
////
